/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
import {useDispatch} from 'react-redux';
import {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import {t} from 'i18next';
import DocumentStatusThreeTable from '../DocumentStatusThreeTable';
import {STATUS_MODEL} from '../../enums/statusEnum';
import {TABLES} from '../../Apis/Tables';

const DocumentStatusThreeApp = (
    { dataTable, optionDownload, docValue, setIsAllChecked, setSelectDocumentsForDelete,
    selectDocumentsForDelete, setDocValue, createDocValue, downloadImg, userType, onUpdate, updated, disabled
    }) => {

    // use hook
    const dispatch = useDispatch();
    // usestate for local state
    const [showAttahModal, setShowAttachModal] = useState(false);
    const [dataApi, setDataApi] = useState('');
    const [documentValue, setDocumentValue] = useState([]);

    useEffect(() => {
        if (updated > 0) {
            const tableDocuments = [dataTable];
            const flattenedDocuments = tableDocuments.flat();

            const hasObjectWithCondition = flattenedDocuments.some((obj) => {
                return obj.id !== null && obj.document === '' && obj.path === null;
            });

            if (hasObjectWithCondition) {
                onUpdate();
            }
        }
    }, [dataTable]);

    // this function control select all id or unSelect all
    const handleDeleteAll = (e) => {
        setIsAllChecked(e.target.checked);
        if (e.target.checked) {
            const selectAllIds = dataTable
                ?.map((item) => {
                    return item?.id !== null && item?.statusId !== STATUS_MODEL.DOCUMENT_VALIDATED ? item.id : null;
                })
                .filter((id) => id !== null);

            setSelectDocumentsForDelete(selectAllIds);
        } else {
            setSelectDocumentsForDelete([]);
        }
    };

    // this function handle only specific id base on selection
    const handleCheckboxChange = (e) => {
        if (e.target.checked && e.target.id !== '' && e.target.id !== null) {
            setSelectDocumentsForDelete([...selectDocumentsForDelete, e.target.id]);
        } else {
            setSelectDocumentsForDelete(selectDocumentsForDelete.filter((removeId) => removeId !== e.target.id));
        }
    };

    // api funtion
    const handleDocumentValue = (item, index) => {
        const data = {
            id: item?.userId || item?.vehicleId,
            document: documentValue[`documentValue-${item?.id || index}`],
            companyDocumentId: item?.companyDocumentId,
        };
        const setData = {
            id: item?.id,
            value: documentValue[`documentValue-${item?.id || index}`],
        };
        if (documentValue[`documentValue-${item?.id || index}`] !== undefined || null || '') {
            if (item?.id != null) {
                dispatch(setDocValue(setData)).then(
                    ({
                         payload: {
                             data: { data, success },
                         },
                     }) => {
                        if (success === true) {
                            toast.success(t('has_been_updated_successfully'));
                            setDocumentValue((prev) => ({
                                ...prev,
                                [`documentValue-${index}`]: '',
                            }));

                            if (onUpdate) onUpdate();
                        } else {
                            toast.error(t('something_went_wrong_2'));
                        }
                    },
                );
            } else {
                dispatch(createDocValue({ data, file: '' })).then(({payload: {data: { data, success }}}) => {
                        if (success === true) {
                            toast.success(t('has_been_updated_successfully'));
                            setDocumentValue((prev) => ({
                                ...prev,
                                [`documentValue-${index}`]: '',
                            }));
                            if (onUpdate) onUpdate();
                        } else {
                            toast.error(t('something_went_wrong_2'));
                        }
                    },
                );
            }
        } else {
            toast.warn(t('please_fill_all_fields'));
        }
    };

    const handleShowAttachModal = (item) => {
        setShowAttachModal(true);
        setDataApi(item);
    }

    const handleDownloadImgApprove = (item) => {
        let option = '';
        switch (userType) {
            case TABLES.EMPLOYEES:
                option = TABLES.EMPLOYEE_DOCUMENT_COMPANY;
                break;
            case TABLES.CONTRACTORS:
                option = TABLES.CONTRACTOR_DOCUMENT_COMPANY;
                break;
            case TABLES.SUPPLIERS:
                option = TABLES.SUPPLIER_DOCUMENT_COMPANY;
                break;
            case TABLES.CONTRACTOR_VEHICLE:
                option = TABLES.CONTRACTOR_VEHICLE_DOCUMENT_COMPANY;
                break;
            case TABLES.SUPPLIER_VEHICLE:
                option = TABLES.SUPPLIER_VEHICLE_DOCUMENT_COMPANY;
                break;
            default:
                option = '';
        }
        dispatch(
            downloadImg({
                id: item?.companyDocumentId,
                option,
                type: item?.companyDocumentPath,
            })
        );
    };

    const handleDownloadImg = (item) => {
        dispatch(
            downloadImg({
                id: item?.id,
                option: optionDownload,
                type: item?.path,
            }),
        );
    }

    const {thead, tbody, tableId, getActionsButtons } = DocumentStatusThreeTable({
        data: dataTable, setSelectedList:setSelectDocumentsForDelete, docValue, userType, setShowAttachModal, setDataApi,
        downloadImg, documentValue, setDocumentValue, optionDownload, disabled,
        handleDocumentValue,
        handleShowAttachModal,
        handleDownloadImgApprove,
        handleDownloadImg
    });

    return {
        showAttahModal,
        dataApi,
        setShowAttachModal,
        tableId,
        thead,
        tbody,
        handleDeleteAll,
        handleCheckboxChange,
        getActionsButtons
    }

}

export default DocumentStatusThreeApp;
